import React from 'react';

export const Vending = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M5 23L29 23M29 23L24.2 17M29 23L24.2 29'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.2 9.8C12.2 7.14903 14.349 5 17 5C19.651 5 21.8 7.14903 21.8 9.8C21.8 12.451 19.651 14.6 17 14.6C14.349 14.6 12.2 12.451 12.2 9.8Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Vending;
